var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 14C19.4814 14 20.125 14.6436 20.125 15.4375V16.25C20.125 18.7839 17.6762 21.75 13 21.75C8.32376 21.75 5.875 18.7839 5.875 16.25V15.4375C5.875 14.6436 6.51859 14 7.3125 14H18.6875Z",
    stroke: "#557CA3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.4375C14.9157 3.4375 16.4688 4.99051 16.4688 6.90625C16.4688 8.82199 14.9157 10.375 13 10.375C11.0843 10.375 9.53125 8.82199 9.53125 6.90625C9.53125 4.99051 11.0843 3.4375 13 3.4375Z",
    stroke: "#20437A",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UserIcon.1da522d3.svg";
export { ForwardRef as ReactComponent };